import { create } from 'zustand';
import { ListProduct } from '../interfaces';
import { Product, SimpleProduct } from '../interfaces/Product';

type ProductsState = {
  allProducts: Product[];
  simpleProducts: SimpleProduct[];
  isLoadingAllProducts: boolean,
  isLoadingSimpleProducts: boolean,
  productTemp: ListProduct | null,
  typeActionProduct: 'add' | 'edit'
  setAllProducts: (product: Product[]) => void;
  setSimpleProducts: (product: SimpleProduct[]) => void;
  setIsLoadingAllProducts: (isLoadingAllProducts: boolean) => void;
  setIsLoadingSimpleProducts: (isLoadingSimpleProducts: boolean) => void;
  setProductTemp: (product: ListProduct) => void;
  setTypeActionProduct: (typeActionProduct: 'add' | 'edit') => void;
};

export const useProductStore = create<ProductsState>((set, getState) => ({
  allProducts: [],
  simpleProducts: [],
  isLoadingAllProducts: false,
  isLoadingSimpleProducts: false,
  productTemp: null,
  typeActionProduct: 'add',
  setAllProducts: (products) => set({ allProducts: products }),
  setSimpleProducts: (products) => set({ simpleProducts: products }),
  setIsLoadingAllProducts: (isLoadingAllProducts) => set({ isLoadingAllProducts }),
  setIsLoadingSimpleProducts: (isLoadingSimpleProducts) => set({ isLoadingSimpleProducts }),
  setProductTemp: (product) => set({ productTemp: product }),
  setTypeActionProduct: (typeActionProduct) => set({ typeActionProduct: typeActionProduct }),
}));